import React from 'react';

import LinkMore from '@app/components/UI/LinkMore/LinkMore';
import MiddleText from '@app/components/UI/MiddleText/MiddleText';

interface AreaServiceFees {
	caption: string;
	price?: number;
}

interface AreaServiceDriveFee {
	caption: string;
	price: number;
	footnote?: string;
}

interface AreaServicePatternProps {
	title: string;
	subtitle?: string;
	description?: string;
	textLink?: string;
	textLinkUrl?: string;
	fees?: Array<AreaServiceFees>;
	drivingFee?: AreaServiceDriveFee;
	warning?: string | React.ReactElement;
	pricePostscript?: React.ReactNode;
}

const AreaServicePattern: React.FC<AreaServicePatternProps> = ({
	title,
	subtitle,
	description,
	textLink,
	textLinkUrl,
	fees,
	drivingFee,
	warning,
	pricePostscript,
}) => {
	return (
		<>
			<MiddleText title={title} subtitle={subtitle} text={description} />
			{warning && warning}
			{textLink && textLinkUrl && (
				<LinkMore linkMoreCaption={textLink} linkMoreHref={textLinkUrl} />
			)}

			<section className="fees">
				<div className="fees-wrapper">
					{fees?.map((fee, index) => (
						<React.Fragment key={index}>
							<p key={`fee-${index}`} className="fees-item">
								{fee.caption && fee.price && (
									<>
										<span className="fees-item__caption">
											<b>{fee.caption}</b>
										</span>
										<span className="fees-item__price">{`\$${fee.price}`}</span>
									</>
								)}
							</p>
							{pricePostscript && <p className="fees-postscript">{pricePostscript}</p>}
						</React.Fragment>
					))}
				</div>
				{drivingFee && (
					<section className="fees-item">
						<span className="fees-item__caption">
							<b>{drivingFee.caption}</b>
						</span>
						<span className="fees-item__price">{`\$${drivingFee.price}*`}</span>
						<p className="fees-item__footnote">{drivingFee.footnote}</p>
					</section>
				)}
			</section>
		</>
	);
};

export default AreaServicePattern;
